export const log = (message: string, ...data: any[]) => {
  if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
    console.log(message, ...data)
  }
}
